const loadedFonts = {}

function loadFont(name, url) {
  // Prevent loading the font uselessly
  if (Object.hasOwnProperty.call(loadedFonts, name)) {
    return Promise.resolve()
  }

  const fontFaceName = `FontFace-${name}`
  const font = new FontFace(fontFaceName, `url(${url})`)
  return font.load().then((loadedFont) => {
    document.fonts.add(loadedFont)
    loadedFonts[name] = { fontFaceName, url }
  })
}


export function getFontFamily(fontFamily) {
  if (loadedFonts[fontFamily]) {
    return loadedFonts[fontFamily].fontFaceName
  }

  return fontFamily
}

/*
| @param {object[]} fonts - Fonts to load.
| @param {string} fonts[].name - Name of the font to load.
| @param {string} fonts[].url - URL to fetch the font.
| @returns {Promise} Resolves when all the fonts are loaded
*/
export function loadFonts(fonts) {
  return Promise.all([...fonts.map(font => loadFont(font.name, font.url))])
}
